import {UserLevelHistoryDomain} from "../../domain/user/UserLevelHistoryDomain"
import {AssetLunarUsageId} from "../../id/asset/AssetLunarUsageId"
import {AssetSolarUsageId} from "../../id/asset/AssetSolarUsageId"
import {AssetStarUsageId} from "../../id/asset/AssetStarUsageId"
import {UserId} from "../../id/user/UserId"
import {UserLevelHistoryId} from "../../id/user/UserLevelHistoryId"
import {UserLevelId} from "../../id/user/UserLevelId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 사용자 레벨 기록
 */
export class UserLevelHistoryValueObject implements ValueObject, UserLevelHistoryDomain {
    /**
     * 기본키
     */
    id: UserLevelHistoryId
    /**
     * 사용자 ID
     */
    userId: UserId
    /**
     * 사용자 레벨 ID
     */
    userLevelId: UserLevelId
    /**
     * 루나 지급 ID
     */
    assetLunarUsageId?: AssetLunarUsageId
    /**
     * 솔라 지급 ID
     */
    assetSolarUsageId?: AssetSolarUsageId
    /**
     * 스타 지급 ID
     */
    assetStarUsageId?: AssetStarUsageId
    /**
     * 생성일
     */
    createdAt: Date

    constructor(o: Record<keyof UserLevelHistoryDomain, any>) {
        this.id = BigInt(o.id)
        this.userId = BigInt(o.userId)
        this.userLevelId = BigInt(o.userLevelId)
        if (o.assetLunarUsageId !== undefined && o.assetLunarUsageId !== null) {
            this.assetLunarUsageId = BigInt(o.assetLunarUsageId)
        }
        if (o.assetSolarUsageId !== undefined && o.assetSolarUsageId !== null) {
            this.assetSolarUsageId = BigInt(o.assetSolarUsageId)
        }
        if (o.assetStarUsageId !== undefined && o.assetStarUsageId !== null) {
            this.assetStarUsageId = BigInt(o.assetStarUsageId)
        }
        this.createdAt = new Date(o.createdAt)
    }
}
